if (!customElements.get('custom-menu-drawer')) {
class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel]'));

    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.switchTab(tab)));
    this.querySelectorAll('[data-menu-drawer-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });

    // Hydrate whichever panel is visible on load (Categories, no <template> there
    // so this just wires up its interactive bits).
    this.panels.forEach((panel) => {
      if (!panel.hidden) this.hydratePanel(panel);
    });
  }

  open() {
    this.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => this.classList.add('is-open'));
  }

  close() {
    this.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.setTimeout(() => {
      this.hidden = true;
    }, 250);
  }

  switchTab(activeTab) {
    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === activeTab.getAttribute('aria-controls');
      panel.hidden = !isActive;
      if (isActive) this.hydratePanel(panel);
    });
  }

  // Clones a panel's <template> contents into the live DOM the first
  // time that tab is opened. Images inside <template> are never
  // fetched by the browser until this runs.
  hydratePanel(panel) {
    if (panel.dataset.hydrated === 'true') return;

    const template = panel.querySelector('template[data-panel-template]');
    if (template) {
      panel.appendChild(template.content.cloneNode(true));
      template.remove();
    }

    panel.dataset.hydrated = 'true';
    this.bindGroupToggles(panel);
    this.bindSeeAll(panel);
    this.bindSearch(panel);
    if (window.initTypingPlaceholders) window.initTypingPlaceholders(panel);
  }

  bindGroupToggles(scope) {
    scope.querySelectorAll('[data-group-toggle]').forEach((btn) => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', () => {
        const group = btn.closest('.custom-menu-drawer__group');
        const willExpand = !group.classList.contains('is-expanded');

        // Accordion behavior: close every other group in this panel first.
        const panel = btn.closest('[data-panel]') || scope;
        panel.querySelectorAll('.custom-menu-drawer__group').forEach((otherGroup) => {
          if (otherGroup === group) return;
          otherGroup.classList.remove('is-expanded');
          const otherToggle = otherGroup.querySelector('[data-group-toggle]');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        });

        group.classList.toggle('is-expanded', willExpand);
        btn.setAttribute('aria-expanded', String(willExpand));
      });
    });
  }

  bindSeeAll(scope) {
    scope.querySelectorAll('[data-see-all]').forEach((btn) => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', () => {
        const list = btn.closest('.custom-menu-drawer__brands-other').querySelector('[data-collapsible-list]');
        const expanded = list.classList.toggle('is-expanded');
        btn.textContent = expanded ? btn.dataset.labelLess : btn.dataset.labelMore;
      });
    });
  }

  bindSearch(scope) {
    scope.querySelectorAll('[data-search-input]').forEach((input) => {
      if (input.dataset.bound === 'true') return;
      input.dataset.bound = 'true';

      const field = input.closest('.custom-menu-drawer__search-field');
      const clearBtn = field ? field.querySelector('[data-search-clear]') : null;

      let timer;
      input.addEventListener('input', () => {
        if (clearBtn) clearBtn.hidden = input.value.length === 0;
        window.clearTimeout(timer);
        timer = window.setTimeout(() => this.filterPanel(input), 150);
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          input.value = '';
          clearBtn.hidden = true;
          this.filterPanel(input);
          input.focus();
        });
      }
    });
  }

  filterPanel(input) {
    const panel = input.closest('[data-panel]');
    const term = input.value.trim().toLowerCase();
    const items = panel.querySelectorAll('[data-search-item]');
    let visibleCount = 0;

    items.forEach((item) => {
      const match = item.dataset.searchTerm.toLowerCase().includes(term);
      item.classList.toggle('is-search-hidden', !match);
      if (match) visibleCount += 1;
    });

    const emptyState = panel.querySelector('[data-search-empty]');
    if (emptyState) emptyState.hidden = visibleCount !== 0;

    // While searching, auto-expand any category group that has a match,
    // and show every "other brand" row (ignore the 3-item collapse).
    panel.querySelectorAll('.custom-menu-drawer__group').forEach((group) => {
      if (!term) return;
      const hasVisible = group.querySelectorAll('[data-search-item]:not(.is-search-hidden)').length > 0;
      if (hasVisible) group.classList.add('is-expanded');
    });

    const collapsibleList = panel.querySelector('[data-collapsible-list]');
    if (collapsibleList) collapsibleList.classList.toggle('is-expanded', term.length > 0);
  }
}

customElements.define('custom-menu-drawer', MenuDrawer);
}

// Wire up any trigger button: <button data-menu-drawer-open="MenuDrawer-{{ section.id }}">
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-drawer-open]').forEach((btn) => {
    if (btn.dataset.menuDrawerBound === 'true') return;
    btn.dataset.menuDrawerBound = 'true';
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-menu-drawer-open');
      const drawer = document.getElementById(id);
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else if (drawer) {
        console.warn(
          `[menu-drawer] Element with id "${id}" was found but isn't a <custom-menu-drawer> element (or wasn't upgraded yet). Check for a duplicate id, or that the menu-drawer section is only rendered once on the page.`
        );
      } else {
        console.warn(`[menu-drawer] No element with id "${id}" found on the page.`);
      }
    });
  });
});